<div class="wrapper">

  <div class="head-text">Please Select Your Monthly Giving Option</div>

  <div class="switch-section">
    <button *ngFor="let btn of switchBtns" class="button-block" [ngClass]="{'active': config?.payType===btn?.button}" (click)="switchBtn(btn?.button)" mat-stroked-button>
      <div class="top-icon">
        <i class="{{btn?.topIconClass}}"></i>
      </div>
      <div class="heading">{{btn?.heading}}</div>
      <div class="desc">{{btn?.desc}}</div>
      <div class="bottom-icon">
        <div *ngFor="let icon of btn?.bottomIconClass" class="block"><i class="{{icon}}"></i></div>
      </div>
    </button>
  </div>

</div>